import http from '@/utils/http'
import config from '@/utils/host'

const api5001 = '/api/5001'
const api5002 = '/api/5002'

// 账号密码操作
export function login(data) {
  return http.post(config.BASE_URL.WG + api5001 + '/sso/login', data)
}

/* 验证注册邮箱验证码 */
export function verifyRegisterEmail(data) {
  return http.post(config.BASE_URL.WG + api5002 + '/customer/facade/register/check_email_code', data)
}

/* 注册公司 */
export function registerCompany(data) {
  return http.post(config.BASE_URL.WG + api5002 + '/customer/facade/register/company', data)
}

/* 发送注册邮箱验证码 */
export function getCode(data) {
  return http.post(config.BASE_URL.WG + api5002 + '/customer/facade/register/send_email_code', data)
}

/* 验证重置密码邮箱验证码 */
export function resetPwdCode(data) {
  return http.post(config.BASE_URL.WG + api5002 + '/customer/facade/reset/check_email_code', data)
}

/* 重置密码 */
export function resetPwd(data) {
  return http.post(config.BASE_URL.WG + api5002 + '/customer/facade/reset/pwd', data)
}

/* 发送重置密码邮箱验证码 */
export function getResetPwd(data) {
  return http.post(config.BASE_URL.WG + api5002 + '/customer/facade/reset/send_email_code', data)
}
